// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_my-1";
export var rowFirst = "_my-3";
export var rowLast = "_my-5";
export var rowMiddle = "_my-4";
export var ticketListScroll = "_my-2";
export var ticketStack = "_my-0";